import Button from "app/components/Button";
import InfoIcon from "app/components/Icons/InfoIcon";
import { validateTeamFormMembers } from "app/containers/OnBoarding/helpers";
import { selectTeamForm } from "app/containers/OnBoarding/redux/selector";
import { actions } from "app/containers/OnBoarding/redux/slice";
import { selectUserFormData } from "app/redux/selector";
import plus from "assets/svgs/ic_plus_primary.svg";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddMember from "../components/AddMember";

interface FormThreeProps {
  readonly onProceed: () => void;
  readonly isOnboardingTeamPage: boolean;
}

export default function FormThree({
  onProceed,
  isOnboardingTeamPage,
}: FormThreeProps) {
   const navigate = useNavigate();
  const userData = useSelector(selectUserFormData);
  const { members, isMemberAdded } = useSelector(selectTeamForm);
  const dispatch = useDispatch();

  const handleSubmit = () => {
    const errors = validateTeamFormMembers(members,userData.email);
    if (errors.length > 0) {
      errors.forEach((error) => {
        const name = error.name.split("-")[0];
        const index = parseInt(error.name.split("-")[1]);
        const _ = { index, name, error: error.error };
        dispatch(actions.updateTeamMemberError(_));
      });
      return;
    }
    onProceed();
  };

  const isDisabled = () => {
    if (members.length < 1) return true;

    return members.some((member) =>
      Object.values(member).some(
        (field: any) => !field?.value || field.value.trim() === ""
      )
    );
  };

  return (
    <div className="flex flex-col gap-4">
      <h5 className="text-lg text-center text-black font-medium leading-[27px]">
        Add members
      </h5>
      {/* Add member and role */}
      <div className="flex flex-col gap-4">
        {members?.map((member, index) => (
        <AddMember index={index} member={member} />
        ))}
      </div>
      {members.length < 5 ? (
        <button
          className="flex flex-row gap-[6px] items-center w-fit"
          onClick={() => dispatch(actions.addTeamMember())}
        >
          <img src={plus} alt="plus" width={16} height={16} />
          <p className="text-sm text-primary font-medium leading-[21px] mb-0 mt-1">
            Member
          </p>
        </button>
      ) : (
        <p className="text-[11px] leading-[18px] text-danger flex items-center gap-[4px]">
          <InfoIcon size="16" color="#EB5757" />
          <span className="mt-[2px]">
            You've reached the member limit for this step.
          </span>
        </p>
      )}
      {isOnboardingTeamPage && (
        <div className="flex flex-col justify-center items-center gap-[16px] mt-6">
          <Button
            className="w-[390px] h-[56px]"
            onClick={handleSubmit}
            disabled={isDisabled()}
            isLoading={isMemberAdded}
          >
            Continue
          </Button>
          <button
            onClick={() => {
               navigate("/onboarding/welcome?callback=/app/home");
              // dispatch(actions.setTeamFormActiveIndex(4));// Skip to plan selection
            }}
            // to="#"
            className="text-black font-normal leading-[24px] text-center mb-0 mt-1"
          >
            Skip for now
          </button>
        </div>
      )}
    </div>
  );
}
